import { render, staticRenderFns } from "./GenerateStickerDialog.vue?vue&type=template&id=4c828a01"
import script from "./GenerateStickerDialog.vue?vue&type=script&lang=js"
export * from "./GenerateStickerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports